import { msalInstance } from "./msalInstance";

export async function acquireToken() {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
        throw new Error("No Entra ID account found");
    }

    const scope = `${process.env.REACT_APP_AZURE_AD_CLIENT_ID}/.default`;
    const request = {
        scopes: [scope],
        account: accounts[0],
    };

    try {
        const response = await msalInstance.acquireTokenSilent(request);
        return response.accessToken;
    } catch (error) {
        console.error("Failed to acquire token silently:", error);
        throw error;
    }
}
